"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var IStringHandler = require("../../interfaces/IStringHandler");
var BaseStringHandler = /*#__PURE__*/function (_IStringHandler) {
  function BaseStringHandler() {
    (0, _classCallCheck2["default"])(this, BaseStringHandler);
    return _callSuper(this, BaseStringHandler, arguments);
  }
  (0, _inherits2["default"])(BaseStringHandler, _IStringHandler);
  return (0, _createClass2["default"])(BaseStringHandler, [{
    key: "validate",
    value: function validate() {
      return false;
    }
  }, {
    key: "format",
    value: function format(value) {
      return value;
    }
  }]);
}(IStringHandler);
module.exports = BaseStringHandler;